/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "location--sprite",
  "use": "location--sprite-usage",
  "viewBox": "0 0 22 31",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 31\" id=\"location--sprite\"><path d=\"M21 11.261h.7-.7Zm-9.33 17.766-.527-.461.527.46Zm-1.34 0 .527-.461-.527.46ZM11 .3C5.082.3.3 5.234.3 11.261h1.4C1.7 5.973 5.89 1.7 11 1.7V.3Zm10.7 10.961C21.7 5.234 16.918.3 11 .3v1.4c5.11 0 9.3 4.273 9.3 9.561h1.4Zm-9.503 18.227a63.06 63.06 0 0 0 4.867-6.492c1.156-1.775 2.309-3.771 3.175-5.78.862-2.002 1.461-4.064 1.461-5.955h-1.4c0 1.62-.52 3.48-1.347 5.4-.824 1.912-1.932 3.836-3.062 5.571a61.583 61.583 0 0 1-4.748 6.334l1.054.922Zm-2.394 0a1.586 1.586 0 0 0 2.394 0l-1.054-.922a.186.186 0 0 1-.286 0l-1.054.922ZM.3 11.26c0 1.892.6 3.953 1.461 5.954.866 2.01 2.02 4.006 3.175 5.78a62.946 62.946 0 0 0 4.867 6.493l1.054-.922a61.587 61.587 0 0 1-4.748-6.334c-1.13-1.735-2.238-3.659-3.062-5.57C2.22 14.74 1.7 12.88 1.7 11.261H.3ZM11 15.724c-2.37 0-4.331-1.986-4.331-4.463h-1.4c0 3.216 2.553 5.863 5.731 5.863v-1.4Zm4.331-4.463c0 2.477-1.96 4.463-4.331 4.463v1.4c3.178 0 5.731-2.647 5.731-5.863h-1.4ZM11 6.798c2.37 0 4.331 1.986 4.331 4.463h1.4c0-3.216-2.553-5.863-5.731-5.863v1.4Zm-4.331 4.463c0-2.477 1.96-4.463 4.331-4.463v-1.4c-3.178 0-5.731 2.647-5.731 5.863h1.4Z\" fill=\"#232323\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
